import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { getRandomInt, randomDataArr } from '../helpers'

import Campaigns from './Campaigns'

const EventPage = ({
  history,
  location,
  match,
  campaigns,
  active,
  past,
}) => {
  if (campaigns.length) {
    return (
      <div className="container content">
        { active.length > 0 && 
          <div>
            <h2>Active Campaigns</h2>
            <Campaigns collection={active} />
          </div>
        }
        { past.length > 0 && 
          <div>
            <h2>Past Campaigns</h2>
            <Campaigns collection={past} />
          </div>
        }
      </div>
    )
  } else {
    return <Redirect to="/events"/>
  }
}

function mapStateToProps(state, props) {
  const campaigns = state.campaigns.active
    .filter(item => item.eventId == props.match.params.id);
  const active = campaigns.filter(item => item.active);
  const past = campaigns.filter(item => !item.active);
  return { campaigns, active, past }
}

export default connect(mapStateToProps)(EventPage)


// WEBPACK FOOTER //
// ./src/components/EventPage.js